module.exports = __webpack_public_path__ + "static/media/reasons-for-attendance-icon.2c7ac152.svg";